import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { DropdownButton, MenuItem } from 'react-bootstrap'

import allOptions from './options.json'

const AnalyzeButton = ({ ids = [], dataClasses = [] }) => {
  const form = useRef(null)
  let isDisabled = dataClasses.length !== 1

  const dc = dataClasses.length > 0 ? dataClasses[0].toLowerCase() : '-'

  if (!allOptions[dc]) isDisabled = true
  const options = allOptions[dc] ?? {}

  const handleOnSelect = (key = '') => {
    debugger
    if (key.match(/^GI\|/g)) {
      form.current.mode.setAttribute('value', "''")
      form.current.convert.setAttribute('value', key.substr(3))
      form.current.action = '/cgi-bin/get_interactions.pl'
    } else {
      form.current.mode.setAttribute('value', 'FieldAnalysis')
      form.current.convert.setAttribute('value', key)
      form.current.action = '/cgi-bin/get_analysis.pl'
    }
    form.current.submit()
  }

  return (
    <>
      <form method="post" action="/cgi-bin/get_analysis.pl" ref={form}>
        <input type="hidden" key="mode" name="mode" value="''" />
        <input type="hidden" key="db" name="db" value={dc} />
        <input type="hidden" key="convert" name="convert" value="" />
        {ids.map((id) => (
          <input type="hidden" key={id} name="items" value={id} readOnly />
        ))}
      </form>
      <DropdownButton
        id="hitlist-conversion"
        bsStyle="primary"
        onSelect={handleOnSelect}
        disabled={isDisabled}
        title={'Analyze'}>
        <MenuItem
          key="freqHeader"
          header
          style={{ fontStyle: 'italic', color: 'steelblue' }}>
          <b>For the selected records, analyze frequencies of values of</b>
        </MenuItem>
        {(options?.frequencies ?? []).map((opt) => (
          <MenuItem key={opt.convert} eventKey={opt.convert}>
            &emsp;
            {opt.optionName}
          </MenuItem>
        ))}
        <MenuItem
          key="intnHeader"
          header
          style={{ fontStyle: 'italic', color: 'steelblue' }}>
          <b>For the selected records, browse Interactions</b>
        </MenuItem>
        {(options?.interactions ?? []).map((opt) => (
          <MenuItem key={'GI|' + opt.convert} eventKey={'GI|' + opt.convert}>
            &emsp;
            {opt.optionName}
          </MenuItem>
        ))}
      </DropdownButton>
    </>
  )
}

AnalyzeButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
  dataClasses: PropTypes.arrayOf(PropTypes.string),
}

export default AnalyzeButton
